import React from "react";
import { Button } from "react-bootstrap";
import { makeStyles } from "@material-ui/core";
import saveGTMEvents from "../../gtm";
import comms_chat from "../../../assets/images/comm_chat.png";
import pauseImg from "../../../assets/images/pauseClassImg.png";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: "40px 16px",
    margin: "10% auto 16px",
  },
  image: {
    marginBottom: "16px",
  },
  bold: {
    fontWeight: 700,
  },
  message: {
    color: "#525252",
    fontSize: "14px",
    marginBottom: "48px",
  },
  subtext: {
    color: "#525252",
    fontSize: "14px",
    marginBottom: "20px",
  },
  button: {
    border: "1px solid #25D366",
    color: "#25D366",
    padding: "12px 24px",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 8,
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#e8f5e9",
    },
  },
  icon: {
    marginLeft: 8,
  },
  btnContainer: {
    border: "1px solid #25D366",
    color: "#25D366",
    background: "#FFFFFF",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    marginTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    "&:hover": {
      background: "#FFFFFF",
      color: "#25D366",
      border: "1px solid #25D366",
    },
  },
}));

export const ClassesPausedNotice = ({ studentEmail, pauseClassDates }) => {
  const classes = useStyles();

  const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY");
  };

  return (
    <div className={classes.root}>
      <img src={pauseImg} alt="pause" className={classes.image} />

      <p variant="body1" className={classes.message}>
        Your classes are paused from{" "}
        <span className={classes.bold}>
          {formatDate(pauseClassDates?.pauseStartTime)}
        </span>{" "}
        to{" "}
        <span className={classes.bold}>
          {formatDate(pauseClassDates?.pauseEndTime)}
        </span>
        .
        <br />
        You cannot add any new classes at this time.
      </p>

      <p variant="body1" className={classes.subtext}>
        We are available on WhatsApp in case you have any queries or concerns
      </p>

      <Button
        className={classes.btnContainer}
        onClick={() => {
          saveGTMEvents("whatsapp_opened", studentEmail);
          window.open("https://wa.me/918884459977");
        }}
      >
        Chat on Whatsapp
        <img src={comms_chat} style={{ marginLeft: "5px" }} alt="wa" />
      </Button>
    </div>
  );
};
